import { saveAs } from 'file-saver';
import { downloadMonitoringSlidesApi } from 'api/monitoringApi';

const pptxMime =
  'application/vnd.openxmlformats-officedocument.presentationml.presentation';

export async function downloadMonitoringSlides({
  customerId,
  monitoringId,
  fetchResult,
}) {
  const slidesSnapshot = fetchResult?.slidesSnapshot;
  if (!slidesSnapshot && !monitoringId) {
    throw new Error('Slides are not available. Run Fetch again.');
  }

  const response = await downloadMonitoringSlidesApi({
    customerId,
    monitoringId,
    slidesSnapshot,
  });

  const base64 = response?.base64;
  if (!base64) {
    throw new Error('Slides file is not available. Run Fetch again.');
  }

  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  const fileName =
    response?.fileName ||
    slidesSnapshot?.fileName ||
    fetchResult?.slidesSnapshot?.fileName ||
    'Monitoring.pptx';
  saveAs(new Blob([bytes], { type: pptxMime }), fileName);
}
